export const SPColor = {
  WHITE: "#fff",
  BLUE: "#74A6D7",

  ORANGE: "#E8552A",
  GREEN: "#80B839",
  LIGHT_BLUE: "#31A7D9",
  DARK_BLUE: "#2F528F",



  YELLOW: "#F3B220",

  BLACK: "#595959",

  SYSTEM1: "#1E7CA6",

  SYSTEM2: "#144d68ff",


  
};
